import { decode } from 'html-entities';
import { createRoot } from 'react-dom/client';
import ImageCarouselProvider from '../../UI/image-carousel/image-carousel-provider';
import ImageCarousel from '../../UI/image-carousel';
import './view.scss';

const RenderCoponent = props => {
    return (
        <div className="image-slider">
            <ImageCarouselProvider {...props}>
                <ImageCarousel />
            </ImageCarouselProvider>        
        </div>
    );
}

const renderBlock = () => {
    const imageSliderElements = document.getElementsByClassName('image-slider-root');
    
    for (let element of imageSliderElements) {
        const props = JSON.parse(decode(JSON.stringify(window.__INITIAL_PROPS__[element.id])));        
        const root = createRoot(element);
        root.render(<RenderCoponent {...props} />);
    }
};

renderBlock();